export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 3